import classNames from "classnames";
import { useSelector } from "react-redux";

// Constants
import { TopNavigationMobileTypes } from "constants/navigation/topNavigationMobile";

// Helpers
import { isUrlActive, isUrlInclude } from "helpers/is";

// Hooks
import useTranslate from "hooks/useTranslate";
import * as gamesSelector from "redux/game/selectors";

import "./styles.sass";

export type TopNavigationItemProps = {
  navigationItem: TopNavigationMobileTypes;
  onInitReal: () => void;
};

const TopNavigationMobileItem = (props: TopNavigationItemProps) => {
  const { navigationItem, onInitReal } = props;

  const t = useTranslate();
  const filter = useSelector(gamesSelector.filter);
  const { providers } = filter;

  const link = navigationItem.link ?? "";

  const navigationClass = classNames("TopNavigationMobileItem", {
    active:
      navigationItem.id === 0 ||
      (navigationItem.id === 4 &&
        providers?.includes(navigationItem?.value?.[0] ?? ""))
        ? isUrlActive(link)
        : isUrlInclude(link),
  });

  const iconClass = classNames("TopNavigationMobileItem__icon", {
    // eslint-disable-next-line camelcase
    TopNavigationMobileItem__icon_old: navigationItem.id !== 4,
  });

  return (
    // eslint-disable-next-line react/jsx-handler-names
    <div onClick={onInitReal} className={navigationClass}>
      {navigationItem.label && (
        <div className="TopNavigationMobileItem__label" />
      )}
      <div className={iconClass}>{navigationItem.icon}</div>
      <div className="TopNavigationMobileItem__name">
        {navigationItem.nameImage ?? t(navigationItem.name)}
      </div>
    </div>
  );
};

export default TopNavigationMobileItem;
